import React, { useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ConfirmDialog } from "primereact/confirmdialog";
import Entidad from "./Entidad";
import Denominacion from "./Denominacion";
import { useLocation, useNavigate } from "react-router-dom";
import Toolbar from "../../componentes/toolbar/Toolbar";
import { setMessageError, setMessageSuccess } from "../../sliceRedux/Reserva.slice";
import useFullPageLoader from "react-comun-seps/lib/components/FullPageLoaderHooks/useFullPageLoader";
import { useDispatch, useSelector } from "react-redux";
import RenderToast from "../../componentes/RenderToast";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";

const Nuevo = () => {
  const toast = useRef(null);
  const stepperRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const dispatch = useDispatch();
  const { datos } = location.state || {};
  const messageError = useSelector((state) => state.reserva.messageError);
  const messageSuccess = useSelector((state) => state.reserva.messageSuccess);

  useEffect(() => {
    if (messageSuccess != "") {
      RenderToast(toast, "success", "Éxito", messageSuccess);
      navigate("/solicitudes", { state: { datos: datos } });
    }
    return () => {
      hideLoader();
      dispatch(setMessageSuccess(""));
    };
  }, [messageSuccess]);

  useEffect(() => {
    if (messageError != "") {
      RenderToast(toast, "error", "Error", messageError);
    }
    return () => {
      document.getElementById("nombreParticular")?.focus();
      hideLoader();
      dispatch(setMessageError(""));
    };
  }, [messageError]);

  const validationSchemaEntidad = Yup.object().shape({
    tipoCaja: Yup.string().required("Campo requerido."),
    tipoVinculo: Yup.string().required("Campo requerido."),
    provincia: Yup.string().required("Campo requerido."),
    canton: Yup.string().required("Campo requerido."),
    parroquia: Yup.string().required("Campo requerido."),
    callePrincipal: Yup.string().required("Campo requerido."),
    calleSecundaria: Yup.string().required("Campo requerido."),
    nombreCroquis: Yup.string().required("Campo requerido."),
  });

  const formikEntidad = useFormik({
    initialValues: {
      tipoCaja: "",
      tipoVinculo: "",
      pais: "",
      provincia: "",
      canton: "",
      parroquia: "",
      callePrincipal: "",
      calleSecundaria: "",
      numero: "",
      referencia: "",
      nombreCroquis: "",
      traduccion: "",
      nombreParticular: "",
      desactivarDisponibilidad: true,
      desactivarOpciones: false,
      tipoCajaDescripcion: "",
      vinculoComunDescripcion: "",
      lstMensaje: [],
      esPertencia: "N",
    },
    validationSchema: validationSchemaEntidad,
    onSubmit: (data) => {
      stepperRef.current.nextCallback();
    },
  });

  return (
    <>
      {loader}
      <Toast ref={toast} />
      <div className="card">
        <Toolbar>
          <React.Fragment>
            <Button
              label="Regresar"
              icon="pi pi-arrow-circle-left"
              type="button"
              severity="info"
              onClick={(e) => {
                navigate("/solicitudes", { state: { datos: datos } });
              }}
            />
          </React.Fragment>
        </Toolbar>
        <div className="text-center">
          <p className="font-semibold">Solicitud de Reserva de Denominación</p>
        </div>

        <Stepper className="stepperReserva" ref={stepperRef} linear style={{ flexBasis: "50rem" }}>
          <StepperPanel panelKey="panelEntidad" header="Entidad">
            <Entidad
              showLoader={showLoader}
              hideLoader={hideLoader}
              dispatch={dispatch}
              formikEntidad={formikEntidad}
              toast={toast}
            />
            <div className="text-center">
              <Button
                label="Siguiente"
                icon="pi pi-arrow-right"
                iconPos="right"
                type="button"
                onClick={(e) => {
                  formikEntidad.handleSubmit();
                }}
              />
            </div>
          </StepperPanel>
          <StepperPanel panelKey="panelDenominacion" header="Denominación">
            <Denominacion
              datos={datos}
              formikEntidad={formikEntidad}
              dispatch={dispatch}
              showLoader={showLoader}
              hideLoader={hideLoader}
            />
            <div className="text-center">
              <Button
                label="Anterior"
                icon="pi pi-arrow-left"
                type="button"
                onClick={(e) => {
                  stepperRef.current.prevCallback();
                  formikEntidad.setFieldValue("desactivarOpciones", false);
                }}
              />
            </div>
          </StepperPanel>
        </Stepper>
      </div>
      <ConfirmDialog />
    </>
  );
};
export default Nuevo;
